import React from 'react'
import { motion } from "framer-motion";
import introthum from '../assets/introImg.png'
import { Link } from 'react-router-dom';
import moneyIcon from '../assets/no-money.png'
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';


export default function Loanpurposeother() {
    return (
        <section className="relative bg-gradient-to-r from-[#011F41] to-[#011F41] py-16 px-4 overflow-hidden">
            <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/20 blur-3xl rounded-full"></div>
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                {/* Left Image */}
                  <motion.div
                    initial={{ opacity: 0, x: 80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <p className="ms-text-secondary uppercase font-semibold text-lg mb-2">
                        Life Happens
                    </p>

                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-snug mb-4">
                        Helping You Navigate Unexpected Financial Situations
                    </h2>

                    
                    <ul className='flex-col py-4 text-lg text-white'>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Insurance Premiums</li>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Laptop or Mobile Repair</li>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Last-Minute Bookings</li>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Family Commitments</li>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Existing EMI Obligations</li>
                        <li className='py-2 flex gap-3 items-center'> <span className='border p-2 rounded'> <LibraryAddCheckIcon/> </span> Professional Expenses</li>
                    </ul>

                </motion.div>
               

                {/* Right Content */}
               <motion.div
                    initial={{ opacity: 0, x: -80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="relative"
                >
                    <img
                        src={moneyIcon}
                        alt="About"
                        className="rounded-2xl w-100 object-cover"
                    />

                    {/* Badge */}
                   
                </motion.div>

            </div>
        </section>
    )
}
